import React from 'react';
import styled from 'styled-components';
import { ArrowLeft, ArrowRight, LayoutDashboard, Book } from 'lucide-react';
import { Link } from 'react-router-dom';
import { breakpoints } from '@/layouts/breakpoints';

const StyledComp = styled.div`
  border-top: 1px solid #e2e2e2;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 96px;
  padding: 0 80px;

  @media (max-width: ${breakpoints.medium}) {
  padding: 0 20px;
  }

  .af-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 200px;

    @media (max-width: ${breakpoints.medium}) {
      grid-template-columns: 1fr ;
      .af-right {
        padding-right: 0;
        padding-left: 0;
      }
      .af-left {
        padding-right: 0;
        padding-left: 0;
        border-right: 0px solid #e2e2e2;
        border-bottom: 1px solid #e2e2e2;
      }
    }
  }

  .af-left {
    padding: 2.5rem 2.5rem 2.5rem 0;
    border-right: 1px solid #e2e2e2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .af-right {
    padding: 2.5rem 0 2.5rem 2.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .af-eyebrow {
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #999;
  }

  .af-back-sub {
    font-size: 13px;
    color: #999;
    line-height: 1.55;
    margin: 0.5rem 0 0;
    max-width: 200px;
  }

  .af-ctas {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 1.75rem;
  }

  .af-cta {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 16px;
    border-radius: 10px;
    text-decoration: none;
    border: 1px solid #e2e2e2;
    transition: border-color 0.15s ease;

    &:hover {
      border-color: #bbb;
    }
  }

  .af-cta-icon {
    width: 38px;
    height: 38px;
    border-radius: 8px;
    background: #f4f4f4;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .af-cta-text {
    flex: 1;
  }

  .af-cta-title {
    font-size: 14px;
    font-weight: 500;
    color: #111;
    margin: 0;
    line-height: 1.3;
  }

  .af-cta-sub {
    font-size: 12px;
    color: #999;
    margin: 2px 0 0;
  }

  .af-cta-arrow {
    color: #bbb;
    flex-shrink: 0;
  }

  .af-cta--primary {
    background: #111;
    border-color: #111;

    &:hover {
      background: #222;
      border-color: #222;
    }

    .af-cta-icon {
      background: rgba(255, 255, 255, 0.12);
    }

    .af-cta-title {
      color: #fff;
    }

    .af-cta-sub {
      color: rgba(255, 255, 255, 0.5);
    }

    .af-cta-arrow {
      color: rgba(255, 255, 255, 0.4);
    }
  }
`;

const BackLink = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #111;
  margin-top: 1.75rem;

  .back-circle {
    width: 24px;
    height: 32px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    transition: border-color 0.15s ease;
  }

  .back-label {
    font-size: 15px;
    font-weight: 500;
  }

  &:hover .back-circle {
    border-color: #888;
  }
`;
const ArticleFooter = ({
} ) => {
  return (
    <StyledComp>
      <div className="af-grid">

        <Link className="af-left" to="/blog">
          <span className="af-eyebrow">The blog</span>
          <div>
            <BackLink >
              <span className="back-circle">
                <ArrowLeft size={14} strokeWidth={2} />
              </span>
              <span className="back-label">Back to blog</span>
            </BackLink>
            <p className="af-back-sub">More hands-on tutorials and guides.</p>
          </div>
        </Link>

        <div className="af-right">
          <span className="af-eyebrow">Get started</span>
          <div className="af-ctas">

            <Link to="/dashboard" className="af-cta">
              <span className="af-cta-icon">
                <LayoutDashboard size={17} strokeWidth={1.75} color="#666" />
              </span>
              <span className="af-cta-text">
                <p className="af-cta-title">Go to dashboard</p>
                <p className="af-cta-sub">Pick up where you left off</p>
              </span>
              <ArrowRight size={14} strokeWidth={2} className="af-cta-arrow" />
            </Link>

            <Link to='/docs' className="af-cta af-cta--primary">
              <span className="af-cta-icon">
                <Book size={17} strokeWidth={1.75} color="rgba(255,255,255,0.85)" />
              </span>
              <span className="af-cta-text">
                <p className="af-cta-title">View all docs</p>
                <p className="af-cta-sub">Learn everything else you need</p>
              </span>
              <ArrowRight size={14} strokeWidth={2} className="af-cta-arrow" />
            </Link>

          </div>
        </div>

      </div>
    </StyledComp>
  );
};

export default ArticleFooter;
